import * as types from '../actions/actionTypes';

const initialState = {
  user: null,
  loggingIn: true,
  accountType: null,
  accountData: {},
  organizationDisplayName: null,
  IAVToken: null,
  userExists: false,
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
  case types.SET_USER_EXISTS:
    return {
      ...state,
      userExists: action.userExists,
    };
  case types.GET_IAV_TOKEN:
    return {
      ...state,
      IAVToken: action.IAVToken,
    };
  case types.UPDATE_GIVING_OPTIONS:
    return {
      ...state,
      accountData: {
        ...state.accountData,
        givingOptions: action.givingOptions,
      },
    };
  case types.SET_ORG_DISPLAY_NAME:
    return {
      ...state,
      organizationDisplayName: action.organizationDisplayName,
    };
  case types.SET_ACCOUNT_DATA:
    return {
      ...state,
      accountData: action.accountData,
    };
  case types.SET_ACCOUNT_TYPE:
    return {
      ...state,
      accountType: action.accountType,
    };
  case types.LOGGING_IN:
    return {
      ...state,
      loggingIn: action.loggingIn,
    };
  case types.GOT_USER:
    return {
      ...state,
      user: action.user,
    };
  default:
    return state;
  }
};
